export const bookingCharges = {
  header: {
    title: "Charges",
    titleNew: "New charges",
    sub: "Items to include on the guest's invoice.",
    subNew:
      "For the next invoice. The already-invoiced accommodation is shown above, on its invoice.",
  },
  loading: "Loading charges…",
  empty: {
    title: "No charges recorded",
    titleBilled: "No pending charges",
    sub: "Add accommodation, cleaning, extras or other services.",
    subBilled: "Add a charge to create another invoice for this booking.",
  },
  buttons: {
    addCharge: "Add charge",
    addFirstCharge: "Add first charge",
    manage: "Manage",
    manageTemplatesTitle: "Manage templates",
    add: "Add",
    close: "Close",
    cancel: "Cancel",
    saving: "Saving…",
    saveCharge: "Save charge",
    saveChanges: "Save changes",
    deleting: "Deleting…",
    confirmDelete: "Yes, delete",
    editTitle: "Edit",
    deleteTitle: "Delete",
  },
  table: {
    item: "Item",
    qty: "Qty",
    unitPrice: "Unit price",
    vat: "VAT",
    total: "Total",
  },
  chips: {
    lodging: "Accommodation",
    discount: "Discount",
    autoSynced: "Synced automatically",
  },
  // Resumen de la estancia bajo cada habitación.
  stay: {
    nights: "1 night | {n} nights",
    rooms: "1 room | {n} rooms",
  },

  fields: {
    // De qué habitación es el cargo (reservas de varias habitaciones).
    room: "Room",
    roomAll: "The whole booking",
    roomHint: "If it belongs to one room, it will go on that room's invoice.",
    date: "Date",
    category: "Category",
    quantity: "Quantity",
    unitPriceFull: "Unit price",
    vatPct: "VAT (%)",
    name: "Name",
    price: "Price",
    internalNotes: "Internal notes",
    paymentMethod: "Payment method",
    paymentDate: "Payment date",
    guestCount: "Number of guests",
  },
  placeholders: {
    item: "Select or type an item…",
    egCleaning: "e.g. Cleaning",
    internalNote: "Add internal note…",
  },
  templates: {
    savedTitle: "Saved charges",
    noResults: 'No results for "{query}"',
    emptyPre: "No saved charges. ",
    createOne: "Create one",
    manageTitle: "Custom charges",
    manageSub: "Create reusable charges for your invoices.",
    emptyList: "No saved charges. Add the first one above.",
    noCategory: "No category",
  },
  vat: {
    labelPct: "VAT {rate}%",
  },
  modal: {
    editTitle: "Edit charge",
    addSub: "New item for the invoice",
    editSub: "Edit the charge details",
    totalCalculated: "Calculated total",
  },
  common: {
    optional: "(optional)",
    unspecified: "Not specified",
  },
  invoice: {
    sectionLabel: "Electronic invoice",
  },
  footer: {
    pending: "Pending invoicing",
    totalDue: "Total due",
  },
  deleteModal: {
    title: "Delete charge?",
    sub: "This action cannot be undone.",
  },
  autoCategory: {
    service: "Service",
    fee: "Fee",
    extraGuest: "Extra guest",
    tax: "Tax",
    cityTax: "City tax",
    adjustment: "Adjustment",
    autoFallback: "Automatic charge",
  },
  chargeBasis: {
    percentOfTotal: "Percentage of total",
    perNight: "Per night",
    perPerson: "Per person",
    perPersonPerNight: "Per person per night",
    perStay: "Per booking",
  },
  toast: {
    descRequired: "Description is required.",
    chargeAdded: "Charge added.",
    chargeUpdated: "Charge updated.",
    chargeDeleted: "Charge deleted.",
    chargeSaved: "Charge saved.",
    saveFailed: "Could not save.",
    deleteFailed: "Could not delete.",
    warningTitle: "Warning",
    doneTitle: "Done",
    errorTitle: "Error",
  },
  invoices: {
    title: "Issued invoices",
    noName: "No name",
    conceptCount: "{count} item | {count} items",
    viewPdf: "View PDF",
    sendWhatsapp: "Send via WhatsApp",
    correct: "Correct (corrective)",
    void: "Void (corrective invoice)",
    conceptsFoot:
      "These items are already invoiced. The PDF has the full detail.",
  },
  status: {
    draft: "Draft",
    sent: "Issued",
    processing: "Processing",
    pending: "Pending",
    error: "Error",
    corrected: "Corrected",
    voided: "Voided",
  },
  checkinModal: {
    title: "Registration details",
    bookingLink: "Booking #{code}",
    requestDate: "Request date: {date} at {time}",
  },
  payment: {
    desti: "Pay at destination",
    efect: "Cash",
    movil: "Mobile payment",
    otro: "Other payment methods",
    platf: "Payment platform",
    tarjt: "Credit card",
    trans: "Bank transfer",
    treg: "Gift card",
  },
};
